import React, { useCallback, useEffect, useRef, useState } from "react";
import TableContainer from "../../../components/layout/table-container/table-container";
import UpArrow from "../../../assets/icons/filterArrowUp.svg";
import DownArrow from "../../../assets/icons/filterArrowDown.svg";
import { useDispatch } from "react-redux";
import { manufacturerPremiumList } from "../../../redux/actions/manufacturerActions";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loaderSpinningContainer";
import ManufacturerPremiumListTableData from "./manufacturer-premium-table-data";
import { useNavigate } from "react-router-dom";
import NumberPagination from "../../../components/Pagination/number-pagination";

const ManufacturerPremiumTable = ({ search, page_no, status }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef();
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [manufacturerListData, setManufacturerListData] = useState([]);
  const [openStatus, setOpenStatus] = useState(false);
  const [loading, setLoading] = useState(false);
  const [catchedErrorPopup, setCatchedErrorPopup] = useState(false);
  const [catchedErrorMsg, setCatchedErrorMsg] = useState();

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  const fetchManufacturerList = useCallback(() => {
    dispatch(
      manufacturerPremiumList({ search, page, status }, onSuccess, onError)
    );
    setLoading(true);
  }, [dispatch, search, page, status]);

  useEffect(() => {
    fetchManufacturerList();
  }, [fetchManufacturerList]);

  const onSuccess = (data) => {
    setLoading(false);
    setManufacturerListData(data.data.data);
  };

  const closeCatchedErrPopup = () => {
    setCatchedErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    setCatchedErrorPopup(true);
    setCatchedErrorMsg(err.data.message);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenStatus(false);
    }
  };

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (status) queryParams.push(`status=${status}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  useEffect(() => {
    if (openStatus) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openStatus]);

  return (
    <>
      <TableContainer>
        <thead>
          <tr className="table-rows color_747f9e">
            <th className="table-heads " width={"4%"}>
              #
            </th>
            <th className="table-heads" width={"10%"}>
              Manufacturer ID
            </th>
            <th className="table-heads " width={"10%"}>
              Manufacturer Name
            </th>
            <th className="table-heads text-center" width={"10%"}>
              No. of Orders
            </th>
            <th className="table-heads text-center" width={"12%"}>
              No. of Distributors
            </th>
            <th className="table-heads " width={"10%"}>
              Email Status
            </th>
            <th
              ref={componentRef}
              className="table-heads text-nowrap"
              width={"8%"}
            >
              <span
                className={
                  openStatus ? "Medium_Purple cursor_pointer" : "cursor_pointer"
                }
                onClick={() => setOpenStatus(!openStatus)}
              >
                <span className={status ? "Medium_Purple fw_700" : ""}>
                  Status
                </span>
                {openStatus ? (
                  <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                ) : (
                  <img src={DownArrow} className=" mx-1" alt="v" />
                )}
              </span>
              {openStatus ? (
                <div className=" position-relative">
                  <div className="position-absolute status-container d-flex gap-3 px-3">
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2 cursor_pointer"
                        type="radio"
                        id="Active"
                        name="status"
                        value={"active"}
                        checked={status === "active"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/manufacturer/premium-list?page=1${
                              search ? `&search=${search}` : ""
                            }&status=active`
                          );
                        }}
                      />
                      <label
                        htmlFor="Active"
                        className={
                          status === "active"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Active
                      </label>
                    </div>
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2 cursor_pointer"
                        type="radio"
                        id="Inactive"
                        name="status"
                        value={"inactive"}
                        checked={status === "inactive"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/manufacturer/premium-list?page=1${
                              search ? `&search=${search}` : ""
                            }&status=inactive`
                          );
                        }}
                      />
                      <label
                        htmlFor="Inactive"
                        className={
                          status === "inactive"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Inactive
                      </label>
                    </div>
                    <div className="d-flex align-items-center ">
                      <input
                        className="radio me-2 cursor_pointer"
                        type="radio"
                        id="Draft"
                        name="status"
                        value={"draft"}
                        checked={status === "draft"}
                        onClick={(e) => {
                          setOpenStatus(!openStatus);
                          navigate(
                            `/manufacturer/premium-list?page=1${
                              search ? `&search=${search}` : ""
                            }&status=draft`
                          );
                        }}
                      />
                      <label
                        htmlFor="Draft"
                        className={
                          status === "draft"
                            ? "color_262c3d cursor_pointer"
                            : "color_747f9e cursor_pointer"
                        }
                      >
                        Draft
                      </label>
                    </div>

                    <button
                      className="filter-btn px-2 py-0 my-2 fs_12"
                      style={{ height: "28px" }}
                      onClick={() => {
                        setOpenStatus(!openStatus);
                        navigate(
                          `/manufacturer/premium-list?page=1${
                            search ? `&search=${search}` : ""
                          }`
                        );
                      }}
                    >
                      CLEAR
                    </button>
                  </div>
                </div>
              ) : null}
            </th>
            <th className="table-heads " width={"22%"}>
              Actions
            </th>
          </tr>
        </thead>
        <tbody style={{ position: "relative" }}>
          {loading === true ? (
            <div className="list-spinner-container">
              <LoadingSpinnerTable show={loading} />
            </div>
          ) : manufacturerListData?.manufacturers?.length > 0 ? (
            <>
              {manufacturerListData?.manufacturers?.map((eachRow, index) => (
                <ManufacturerPremiumListTableData
                  key={eachRow.id}
                  data={eachRow}
                  index={index}
                  fetchManufacturerList={fetchManufacturerList}
                  currentPage={manufacturerListData?.pagination?.currentPage}
                />
              ))}
            </>
          ) : (
            <tr>
              <td colSpan="1" className="text-center no-data-container fs_16">
                <span>~ No Data Found ~</span>
              </td>
            </tr>
          )}
        </tbody>
      </TableContainer>
      {manufacturerListData?.pagination?.totalPages > 0 && (
        <NumberPagination
          setCurrentPage={setPage}
          pagination={manufacturerListData?.pagination?.currentPage}
          totalPages={manufacturerListData?.pagination?.totalPages}
          path={"/manufacturer/premium-list"}
          filters={`${queryString}`}
        />
      )}

      <ErrorPopup
        show={catchedErrorPopup}
        title={catchedErrorMsg}
        handleClose={closeCatchedErrPopup}
      />
    </>
  );
};

export default ManufacturerPremiumTable;
